import { GodownDetail as ConsoleGodownDetail } from "../console/GodownDetail";

// The shared godown management page, mounted under the state-head base
// path (reached by opening a godown from a district).
export function GodownDetail() {
  return <ConsoleGodownDetail basePath="/sh" />;
}
